import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { environment } from '../../../environments/environment';
import { CommonUtil } from '../../core/Utils/common-util';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content-tile',
  templateUrl: './content-tile.component.html',
  styleUrls: ['./content-tile.component.css']
})
export class ContentTileComponent implements OnInit, OnDestroy {
  testMessage: any;
  currentFacility: FacilityObject;

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private router: Router,
    private rootScopeService: RootScopeService,
    public commonutil: CommonUtil,
    private _facilityService: FacilityService) {
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  showAskPopup = false;

  @Input() contentData: any;
  @Output() onAction: EventEmitter<String> = new EventEmitter();
  ngOnInit() {
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
    this.cloudBasePath = environment.cloudBasePath;
    const askQuestionLink = ['<a class="askQuestion" href="javascript:;">"' + this.commonutil.translateText('ASK.QUESTION') + '"</a>'];
    this.testMessage = this.commonutil.replaceValueAsHTMLOnTranslatedText('HALOMEDIA.ENROLLED.ASK.QUESTION.MESSAGE', askQuestionLink);
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  doContentAction(event: Event): void {
    this.onAction.emit(this.contentData.contentAction);
  }

  showAskQuestionPopup(event: MouseEvent) {
    if ((<HTMLElement>event.target).nodeName == 'A') { this.showAskPopup = true; }
  }

  closeAskQuestionPopup() {
    this.showAskPopup = false;
  }

  redirectToAttractScreen() {
    if(this.currentFacility?.summary?.facilityRights.attractScreen == 'true') {
      window.location.href = '/equipmentSettings/attractscreen';
    }
  }
}
